import { authGet, authPost, authDelete, authPatch } from '../auth/authFetches';

/** ===================== ROLES ===================== */

/**
 * GET /accessManagement/roles
 * Fetches all roles (with permissions)
 */
export async function getRoles(accessToken: string) {
    const path = `/accessManagement/getRoles`;
    console.log('Fetching all roles with permissions');
    return await authGet(accessToken, path);
}

/** ===================== USERS ===================== */

/**
 * GET /accessManagement/users
 * Fetches all users
 */
export async function getUsers(accessToken: string) {
    const path = `/accessManagement/getUsers`;
    console.log('Fetching all users');
    return await authGet(accessToken, path);
}

/**
 * PATCH /accessManagement/users/{userId}/roles
 * Assigns or removes roles for the given user
 */
export async function updateUser(
    accessToken: string,
    userId: string,
    roleIds: string[],
    roleNames: string[]
) {
    const path = `/accessManagement/updateUser`;
    console.log(`Patching roles for userId ${userId}:`, roleIds);
    return await authPatch(accessToken, path, { userId, roleIds, roleNames });
}

export async function syncUserRoles(accessToken: string) {
    const path = `/accessManagement/syncUserRoles`;
    console.log('Syncing users roles');
    return await authGet(accessToken, path);
}

export async function deleteUser(accessToken: string, userId: string) {
    const path = `/accessManagement/deleteUser?user_id=${encodeURIComponent(userId)}`;
    console.log(`Deleting user with id ${userId}`);
    return await authDelete(accessToken, path);
}
